import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize';
// Styled Components
import { Container, Flex } from '../../styles/globalStyle.js';
//Framer Motion
import { motion, useAnimation } from 'framer-motion';
//Home Component
import {
  HomeAboutSection,
  About,
  Services,
  AccordionHeader,
  AccordionContent,
  AccordionIcon,
} from '../../styles/homeStyles';
//Context
import { useGlobalStateContext } from '../../context/globalContext';
//Scroll Observer
import { useInView } from 'react-intersection-observer';

// import { ReactComponent as CopyrightSVG } from '../assets/svg/copyright.svg';
// import { ReactComponent as TrademarkSVG } from '../assets/svg/trademark.svg';

import { CopyrightSVG, Trademark } from '../../assets/svg/social-icons';

// Accordion Data
const accordionIds = [
  {
    id: 0,
    title: '关于',
    results: [
      { name: '艺术家', link: '/artist' },
      { name: '内涵', link: '/meaning' },
      { name: '哲学思想', link: 'philosophy' },
      { name: '愿景与慈善', link: '/vision-philanthropy' },
      { name: '美与魅', link: '/beauty' },
      { name: '金属', link: '/metal' },
      { name: '承诺', link: '/commitment' },
      { name: '联络方式', link: '/contact' },
    ],
  },
  {
    id: 1,
    title: '场景',
    results: [
      { name: '门厅', link: '/main-video?t=0' },
      { name: '主卧', link: '/main-video?t=155' },
      { name: '卫生间', link: '/main-video?t=203' },
      { name: '客卧', link: 'vision&/main-video?t=228' },
      { name: '电梯', link: '/main-video?t=260' },
      { name: '祈祷室', link: '/main-video?t=299' },
      { name: '女性会客室', link: '/main-video?t=341' },
      { name: '庭院', link: '/main-video?t=450' },
      { name: '飞机', link: '/main-video?t=651' },
      { name: '客厅和餐厅', link: '/main-video?t=711' },
      { name: '游艇', link: '/main-video?t=822' },
      { name: '车库', link: '/main-video?t=945' },
    ],
  },
  {
    id: 2,
    title: '重要信息',
    results: [
      { name: '使用条款协议', link: '/copyright' },
      { name: '免责声明', link: '/copyright' },
      { name: '注意事项', link: '/copyright' },
      { name: '版权', link: '/copyright#copyright' },
      { name: '商标', link: '/copyright#trademarks' },
    ],
  },
];
const copyrightAccordionData = [
  {
    id: 0,
    title: '重要信息',
    results: [
      { name: '使用条款协议', link: '/copyright' },
      { name: '免责声明', link: '/copyright' },
      { name: '注意事项', link: '/copyright' },
      { name: '版权', link: '/copyright#copyright' },
      { name: '商标', link: '/copyright#trademarks' },
    ],
  },
];
const accordionHome = [
  {
    id: 0,
    title: '首页',
    results: [
      {
        name: '超越非凡 ~  远离平凡',
        link: '/',
      },
    ],
  },
  {
    id: 1,
    title: '重要信息',
    results: [
      { name: '使用条款协议', link: '/copyright' },
      { name: '免责声明', link: '/copyright' },
      { name: '注意事项', link: 'copyright' },
      { name: '版权', link: '/copyright' },
      { name: '商标', link: '/copyright' },
    ],
  },
];
const accordionCopyright = [
  {
    id: 0,
    title: '重要信息',
    results: [
      { name: '使用条款协议', link: '/copyright' },
      { name: '免责声明', link: '/copyright' },
      { name: '注意事项', link: 'copyright' },
      { name: '版权', link: '/copyright' },
      { name: '商标', link: '/copyright' },
    ],
  },
];

const HomeAbout = ({ onCursor }) => {
  //Default state, using number for our id. Which ever the number/id is in the state. That will be opened.
  const [expanded, setExpanded] = useState(false);
  const animation = useAnimation();
  const [aboutRef, inView] = useInView({
    triggerOnce: true,
    // Giving our scrollwheel additional 300px before executing animation
    rootMargin: '-300px',
  });

  useEffect(() => {
    if (inView) {
      animation.start('visible');
    }
  }, [animation, inView]);

  return (
    <HomeAboutSection>
      <Container>
        <Flex alignTop center className={'flex'}>
          <Services>
            {/* <h3>Services</h3> */}
            {accordionIds.map((details, index) => (
              <Accordion
                key={index}
                details={details}
                expanded={expanded}
                setExpanded={setExpanded}
                onCursor={onCursor}
              />
            ))}
          </Services>
        </Flex>
      </Container>
    </HomeAboutSection>
  );
};

const Accordion = ({ details, expanded, setExpanded, onCursor }) => {
  const isOpen = details.id === expanded;
  const [hovered, setHovered] = useState(false);
  const { currentTheme } = useGlobalStateContext();
  return (
    <>
      <AccordionHeader
        initial={false}
        onClick={() => setExpanded(isOpen ? false : details.id)}
        whileHover={{
          color: currentTheme === 'dark' ? '#ffffff' : '#000000',
        }}
        onHoverStart={() => setHovered(!hovered)}
        onHoverEnd={() => setHovered(!hovered)}
        onMouseEnter={() => onCursor('hovered')}
        onMouseLeave={onCursor}
      >
        <AccordionIcon>
          <motion.span
            style={{
              background:
                isOpen || hovered
                  ? currentTheme === 'dark'
                    ? 'white'
                    : 'black'
                  : null,
            }}
            animate={{ rotate: isOpen || hovered ? 0 : 45, x: 3 }}
            transition={{ duration: 0.2, ease: [0.6, 0.05, -0.01, 0.9] }}
          ></motion.span>
          <motion.span
            style={{
              background:
                isOpen || hovered
                  ? currentTheme === 'dark'
                    ? 'white'
                    : 'black'
                  : null,
            }}
            animate={{ rotate: isOpen || hovered ? 0 : -45, x: -3 }}
            transition={{ duration: 0.2, ease: [0.6, 0.05, -0.01, 0.9] }}
          ></motion.span>
        </AccordionIcon>
        {details.title}
      </AccordionHeader>
      <AccordionContent
        key='content'
        animate={{ height: isOpen ? '100%' : '0' }}
        transition={{ duration: 0.8, ease: [0.6, 0.05, -0.01, 0.9] }}
      >
        {details.results.map((item) => (
          <Link to={`${item.link}`}>
            {' '}
            <span
              whileHover={{
                color: currentTheme === 'dark' ? '#ffffff' : '#000000',
              }}
              key={item.link}
            >
              {item.name}
            </span>{' '}
          </Link>
        ))}
      </AccordionContent>
    </>
  );
};

const HomeAccordian = ({ onCursor, page }) => {
  //Default state, using number for our id. Which ever the number/id is in the state. That will be opened.
  const [expanded, setExpanded] = useState(false);
  const animation = useAnimation();
  const [aboutRef, inView] = useInView({
    triggerOnce: true,
    // Giving our scrollwheel additional 300px before executing animation
    rootMargin: '-300px',
  });

  useEffect(() => {
    if (inView) {
      animation.start('visible');
    }
  }, [animation, inView]);

  return (
    <HomeAboutSection className={page === 'contact' ? 'contact' : ''}>
      <Container>
        <Flex alignTop center className={'flex'}>
          <Services>
            {accordionHome.map((details, index) => (
              <AccordionHome
                key={index}
                details={details}
                expanded={expanded}
                setExpanded={setExpanded}
                onCursor={onCursor}
              />
            ))}
          </Services>
        </Flex>
      </Container>
    </HomeAboutSection>
  );
};

const AccordionHome = ({ details, expanded, setExpanded, onCursor }) => {
  const isOpen = details.id === expanded;
  const [hovered, setHovered] = useState(false);
  const { currentTheme } = useGlobalStateContext();
  const size = useWindowSize();
  return (
    <>
      <AccordionHeader
        initial={false}
        onClick={() => setExpanded(isOpen ? false : details.id)}
        whileHover={{
          color: currentTheme === 'dark' ? '#ffffff' : '#000000',
        }}
        onHoverStart={() => setHovered(!hovered)}
        onHoverEnd={() => setHovered(!hovered)}
        onMouseEnter={() => onCursor('hovered')}
        onMouseLeave={onCursor}
      >
        <AccordionIcon>
          <motion.span
            style={{
              background:
                isOpen || hovered
                  ? currentTheme === 'dark'
                    ? 'white'
                    : 'black'
                  : null,
            }}
            animate={{ rotate: isOpen || hovered ? 0 : 45, x: 3 }}
            transition={{ duration: 0.2, ease: [0.6, 0.05, -0.01, 0.9] }}
          ></motion.span>
          <motion.span
            style={{
              background:
                isOpen || hovered
                  ? currentTheme === 'dark'
                    ? 'white'
                    : 'black'
                  : null,
            }}
            animate={{ rotate: isOpen || hovered ? 0 : -45, x: -3 }}
            transition={{ duration: 0.2, ease: [0.6, 0.05, -0.01, 0.9] }}
          ></motion.span>
        </AccordionIcon>
        {details.title}
      </AccordionHeader>
      <AccordionContent
        key='content'
        animate={{ height: isOpen ? '100%' : '0' }}
        transition={{ duration: 0.8, ease: [0.6, 0.05, -0.01, 0.9] }}
      >
        {details.results.map((item) => (
          <Link to={`${item.link}`}>
            {' '}
            <span
              className='home'
              whileHover={{
                color: 'eb002a',
                // color: currentTheme === 'dark' ? '#ffffff' : '#000000',
              }}
              key={item.link}
            >
              {item.name}
              {/* Unless You claim <span className='span'>E</span>xtraordinary{' '}
              {size.width < 550 ? (
                <br />
              ) : (
                <ectraSpace style={{ marginLeft: '6px' }} />
              )}
              ~ ordinary claims you. */}
            </span>{' '}
          </Link>
        ))}
      </AccordionContent>
    </>
  );
};

const CopyrightHomeAccordian = ({ onCursor, page }) => {
  //Default state, using number for our id. Which ever the number/id is in the state. That will be opened.
  const [expanded, setExpanded] = useState(false);
  const animation = useAnimation();
  const [aboutRef, inView] = useInView({
    triggerOnce: true,
    // Giving our scrollwheel additional 300px before executing animation
    rootMargin: '-300px',
  });

  useEffect(() => {
    if (inView) {
      animation.start('visible');
    }
  }, [animation, inView]);

  const accordionCopyrightPage = [
    {
      id: 0,
      title: '首页',
      results: [
        {
          name: '超越非凡 ~  远离平凡',
          link: '/',
        },
      ],
    },
  ];

  return (
    <HomeAboutSection className='copyright_home_about'>
      {/* <Container> */}
      <Flex alignTop center className={'flex'}>
        <Services className='copyrightPageAccordian'>
          {accordionCopyrightPage.map((details, index) => (
            <AccordionHome
              key={index}
              details={details}
              expanded={expanded}
              setExpanded={setExpanded}
              onCursor={onCursor}
            />
          ))}
        </Services>
      </Flex>
      {/* </Container> */}
    </HomeAboutSection>
  );
};

const CopyrightAccordion = ({ onCursor }) => {
  //Default state, using number for our id. Which ever the number/id is in the state. That will be opened.
  const [expanded, setExpanded] = useState(false);
  const animation = useAnimation();
  const [aboutRef, inView] = useInView({
    triggerOnce: true,
    // Giving our scrollwheel additional 300px before executing animation
    rootMargin: '-300px',
  });

  useEffect(() => {
    if (inView) {
      animation.start('visible');
    }
  }, [animation, inView]);

  return (
    <HomeAboutSection className='copyrightAccordian'>
      <Container>
        <Flex alignTop center className={'flex'}>
          <Services>
            {/* <h3>Services</h3> */}
            {copyrightAccordionData.map((details, index) => (
              <Accordion
                key={index}
                details={details}
                expanded={expanded}
                setExpanded={setExpanded}
                onCursor={onCursor}
              />
            ))}
          </Services>
        </Flex>
      </Container>
    </HomeAboutSection>
  );
};

const FooterCopyright = ({ onCursor }) => {
  //Default state, using number for our id. Which ever the number/id is in the state. That will be opened.
  const [expanded, setExpanded] = useState(false);
  const animation = useAnimation();
  const [aboutRef, inView] = useInView({
    triggerOnce: true,
    // Giving our scrollwheel additional 300px before executing animation
    rootMargin: '-300px',
  });

  useEffect(() => {
    if (inView) {
      animation.start('visible');
    }
  }, [animation, inView]);

  return (
    // <HomeAboutSection className='copyright_section'>
    //   <Container>
    <Flex alignTop flexEnd className={'flex_copyright'}>
      {/* <Services> */}
      {/* <h3>Services</h3> */}
      {accordionCopyright.map((details, index) => (
        <Copyright
          key={index}
          details={details}
          expanded={expanded}
          setExpanded={setExpanded}
          onCursor={onCursor}
        />
      ))}
      {/* </Services> */}
    </Flex>
    //   </Container>
    // </HomeAboutSection>
  );
};

const Copyright = ({ details, expanded, setExpanded, onCursor }) => {
  const isOpen = details.id === expanded;
  const [hovered, setHovered] = useState(false);
  const { currentTheme } = useGlobalStateContext();
  const size = useWindowSize();
  return (
    <>
      <AccordionHeader
        initial={false}
        onClick={() => setExpanded(isOpen ? false : details.id)}
        whileHover={{
          color: currentTheme === 'dark' ? '#ffffff' : '#000000',
        }}
        onHoverStart={() => setHovered(!hovered)}
        onHoverEnd={() => setHovered(!hovered)}
        onMouseEnter={() => onCursor('hovered')}
        onMouseLeave={onCursor}
        className='copyright'
        style={{
          color: currentTheme === 'dark' ? '#ffffff' : '#000000',
        }}
      >
        <AccordionIcon className='copyright_accoudian_icon'>
          <motion.span
            style={{
              background:
                isOpen || hovered
                  ? currentTheme === 'dark'
                    ? 'white'
                    : 'black'
                  : null,
            }}
            animate={{ rotate: isOpen || hovered ? 0 : 45, x: 3 }}
            transition={{ duration: 0.2, ease: [0.6, 0.05, -0.01, 0.9] }}
          ></motion.span>
          <motion.span
            style={{
              background:
                isOpen || hovered
                  ? currentTheme === 'dark'
                    ? 'white'
                    : 'black'
                  : null,
            }}
            animate={{ rotate: isOpen || hovered ? 0 : -45, x: -3 }}
            transition={{ duration: 0.2, ease: [0.6, 0.05, -0.01, 0.9] }}
          ></motion.span>
        </AccordionIcon>
        {/* {details.title} */}
        {/* <CopyrightSVG />
        <Trademark />  */}
        <div>重要信息 </div>
        {/* {size.width < 768 ? (<br />) : null} */}
      </AccordionHeader>
      <AccordionContent
        // className='accordionContentCopyright'
        key='content'
        animate={{ height: isOpen ? '100%' : '0' }}
        transition={{ duration: 0.8, ease: [0.6, 0.05, -0.01, 0.9] }}
      >
        {/* {details.results.map((item) => ( */}
        <Link to='/copyright'>
          {' '}
          <span
            whileHover={{
              color: currentTheme === 'dark' ? '#ffffff' : '#000000',
            }}
          >
            使用条款协议
          </span>{' '}
        </Link>
        <Link to='/copyright'>
          {' '}
          <span
            whileHover={{
              color: currentTheme === 'dark' ? '#ffffff' : '#000000',
            }}
          >
            免责声明
          </span>{' '}
        </Link>
        <Link to='/copyright'>
          {' '}
          <span
            whileHover={{
              color: currentTheme === 'dark' ? '#ffffff' : '#000000',
            }}
          >
            注意事项
          </span>{' '}
        </Link>
        <Link to='/copyright#copyright'>
          {' '}
          <span
            whileHover={{
              color: currentTheme === 'dark' ? '#ffffff' : '#000000',
            }}
          >
            <CopyrightSVG className='accordianSVG' /> 版权
          </span>{' '}
        </Link>
        <Link to='/copyright#trademarks'>
          {' '}
          <span
            whileHover={{
              color: currentTheme === 'dark' ? '#ffffff' : '#000000',
            }}
          >
            <Trademark className='accordianSVG' /> 商标
          </span>{' '}
        </Link>
        {/*  ))} */}
      </AccordionContent>
    </>
  );
};

export {
  HomeAbout,
  HomeAccordian,
  FooterCopyright,
  CopyrightHomeAccordian,
  CopyrightAccordion,
};
